import React, { useState } from "react";
import "./LoanDetails.scss";
import LoanDetailCard from "./LoanDetailCard";
import LoanProgressBar from "./LoanProgressBar";
import LoanDetailCardNew from "./LoanDetailCardNew";

function LoanDetails({reportCounts, progressBarPercent, goalCompletions, funnelCounts, loanIssuedCounts}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
console.log("progressBarPercent--------------",progressBarPercent);
console.log("goalCompletions--------------",goalCompletions);
console.log("funnelCounts--------------",funnelCounts);
console.log("loanIssuedCounts--------------",loanIssuedCounts);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const formatCurrency = (val) => {
    const formattedCurr = Number(val).toLocaleString("en-US", { minimumFractionDigits: 2 });
    return formattedCurr;
  }

  const loanCardInformation = [
    {
      icon: true,
      iconText: null,
      title: "Total Outstanding Open Loans",
      text1: reportCounts?.total_loan_amount ? `${formatCurrency(parseFloat(reportCounts?.total_outstanding_principal) + parseFloat(reportCounts?.outstanding_fees) + parseFloat(reportCounts?.outstanding_late_fees))}` : "0",
      text2: null,
    },
    {
      icon: true,
      iconText: null,
      title: "Principal Outstanding Open Loans",
      text1: reportCounts?.total_outstanding_principal? formatCurrency(reportCounts?.total_outstanding_principal) : "0",
      text2: null,
    },
    // {
    //   icon: true,
    //   iconText: null,
    //   title: "Interest Outstanding open loans",
    //   text1: "0",
    //   text2: null,
    // },
    {
      icon: true,
      iconText: null,
      title: "Fees outstanding open loans",
      text1: reportCounts?.outstanding_fees? formatCurrency(reportCounts?.outstanding_fees) : "0",
      text2: null,
    },
    {
      icon: true,
      iconText: null,
      title: "Penalty outstanding open loans",
      text1: reportCounts?.outstanding_late_fees? formatCurrency(reportCounts?.outstanding_late_fees) : "0",
      text2: null,
    },
    {
      icon: false,
      iconText: "P",
      title: "Processing Loans",
      text1: reportCounts?.approval_pending_loans_count ? `Count - ${reportCounts?.approval_pending_loans_count}` : "0",
      text2: reportCounts?.approval_pending_loans_amount ? `Amount - ${formatCurrency(reportCounts?.approval_pending_loans_amount)}` : "0",
    },
    {
      icon: false,
      iconText: "O",
      title: "Open Loans",
      text1: reportCounts?.open_loans_count_year ? `${reportCounts?.open_loans_count_year} - This Year` : "0 - This Year",
      text2: reportCounts?.open_loans_count_month ? `${reportCounts?.open_loans_count_month} - This Month` : "0 - This Month",
    },
    {
      icon: false,
      iconText: "F",
      title: "Fully paid loans",
      text1: reportCounts?.fully_paid_count_year ? `${reportCounts?.fully_paid_count_year} - This Year` : "0 - This Year",
      text2: reportCounts?.fully_paid_count_month ? `${reportCounts?.fully_paid_count_month} - This Month` : "0 - This Month",
    },
    // {
    //   icon: false,
    //   iconText: "R",
    //   title: "Fully paid loans",
    //   text1: reportCounts?.fully_paid_count_year ? `${reportCounts?.fully_paid_count_year} - This Year` : "4 - This Year",
    //   text2: reportCounts?.fully_paid_count_month ? `${reportCounts?.fully_paid_count_month} - This Month` : "2 - This Month",
    // },
    {
      icon: false,
      iconText: "Df",
      title: "Default Loans",
      text1: reportCounts?.default_loans_count_year ? `${reportCounts?.default_loans_count_year} - This Year` : "11 - This Year",
      text2: reportCounts?.default_loans_count_month ? `${reportCounts?.default_loans_count_month} - This Month` : "0 - This Month",
    },
    {
      icon: false,
      iconText: "Dn",
      title: "Denied Loans",
      text1: reportCounts?.denied_loans_count_year ? `${reportCounts?.denied_loans_count_year} - This Year` : "10 - This Year",
      text2: reportCounts?.denied_loans_count_month ? `${reportCounts?.denied_loans_count_month} - This Month` : "5 - This Month",
    },
    // {
    //   icon: false,
    //   iconText: "N",
    //   title: "Not Taken up Loans",
    //   text1: "0 - This Year",
    //   text2: "0 - This Month",
    // },
  ];

  const loanCard2Information = [
    {
      icon: false,
      iconText: "T",
      title: (
        <>
          Total Loan<br />
          Applications
        </>
      ),
      text1: funnelCounts?.total_year_amount ? `YTD - $${formatCurrency(parseFloat(funnelCounts?.total_year_amount))} (${funnelCounts?.total_year_count})` : "YTD - 0",
      text2: funnelCounts?.total_month_amount ? `MTD - $${formatCurrency(parseFloat(funnelCounts?.total_month_amount))} (${funnelCounts?.total_month_count})` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "N",
      title: "Not Approved",
      text1: funnelCounts?.notapproved_year_amount ? `YTD - $${formatCurrency(parseFloat(funnelCounts?.notapproved_year_amount))} (${funnelCounts?.notapproved_year_count})` : "YTD - 0",
      text2: funnelCounts?.notapproved_month_amount ? `MTD - $${formatCurrency(parseFloat(funnelCounts?.notapproved_month_amount))} (${funnelCounts?.notapproved_month_count}) ` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "P",
      title: "Pre-Qualification / Screening",
      text1: funnelCounts?.prequal_year_amount ? `YTD - $${formatCurrency(parseFloat(funnelCounts?.prequal_year_amount))} (${funnelCounts?.prequal_year_count})` : "YTD - 0",
      text2: funnelCounts?.prequal_month_amount ? `MTD - $${formatCurrency(parseFloat(funnelCounts?.prequal_month_amount))} (${funnelCounts?.prequal_month_count}) ` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "U",
      title: "Underwriting & Credit Assessment",
      text1: funnelCounts?.underwriting_year_amount ? `YTD - $${formatCurrency(parseFloat(funnelCounts?.underwriting_year_amount))} (${funnelCounts?.underwriting_year_count})` : "YTD - 0",
      text2: funnelCounts?.underwriting_month_amount ? `MTD - $${formatCurrency(parseFloat(funnelCounts?.underwriting_month_amount))} (${funnelCounts?.underwriting_month_count})` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "A",
      title: "Approved (Not Issued) Loans",
      text1: funnelCounts?.approved_year_amount ? `YTD - $${formatCurrency(parseFloat(funnelCounts?.approved_year_amount))} (${funnelCounts?.approved_year_count})` : "YTD - 0",
      text2: funnelCounts?.approved_month_amount ? `MTD - $${formatCurrency(parseFloat(funnelCounts?.approved_month_amount))} (${funnelCounts?.approved_month_count})` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "D",
      title: "Disbursed Loans",
      text1: funnelCounts?.disbursed_year_amount ? `YTD - $${formatCurrency(parseFloat(funnelCounts?.disbursed_year_amount))} (${funnelCounts?.disbursed_year_count})` : "YTD - 0",
      text2: funnelCounts?.disbursed_month_amount ? `MTD - $${formatCurrency(parseFloat(funnelCounts?.disbursed_month_amount))} (${funnelCounts?.disbursed_month_count})` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "P",
      title: "Performing Loans",
      text1: loanIssuedCounts?.performing_year_amount ? `YTD - $${formatCurrency(parseFloat(loanIssuedCounts?.performing_year_amount))} (${loanIssuedCounts?.performing_year_count})` : "YTD - 0",
      text2: loanIssuedCounts?.performing_month_amount ? `MTD - $${formatCurrency(parseFloat(loanIssuedCounts?.performing_month_amount))} (${loanIssuedCounts?.performing_month_count})` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "D",
      title: "Delinquent Loans",
      text1: loanIssuedCounts?.delinquent_year_amount ? `YTD - $${formatCurrency(parseFloat(loanIssuedCounts?.delinquent_year_amount))} (${loanIssuedCounts?.delinquent_year_count})` : "YTD - 0",
      text2: loanIssuedCounts?.delinquent_month_amount ? `MTD - $${formatCurrency(parseFloat(loanIssuedCounts?.delinquent_month_amount))} (${loanIssuedCounts?.delinquent_month_count})` : "MTD - 0",
    },
    {
      icon: false,
      iconText: "C",
      title: "Closure",
      text1: loanIssuedCounts?.closure_year_amount ? `YTD - $${formatCurrency(parseFloat(loanIssuedCounts?.closure_year_amount))} (${loanIssuedCounts?.closure_year_count})` : "YTD - 0",
      text2: loanIssuedCounts?.closure_month_amount ? `MTD - $${formatCurrency(parseFloat(loanIssuedCounts?.closure_month_amount))} (${loanIssuedCounts?.closure_month_count})` : "MTD - 0",
    }
  ];

  //   width, color, leftText, rightText, title;
  const progressBarInformation = [
    {
      width: progressBarPercent?.week ? `${progressBarPercent?.week}%` : "0%",
      color: "bg-success",
      leftText: "Collections/Due",
      rightText: goalCompletions?.current_week_paid_amount ? `${formatCurrency(goalCompletions?.current_week_paid_amount)} / ${formatCurrency(goalCompletions?.current_week_payment_due)}` : "0/0",
      title: `Weekly Goal Completion (${progressBarPercent?.week}%)`,
    },
    {
      width: progressBarPercent?.month ? `${progressBarPercent?.month}%` : "0%",
      color: "bg-warning",
      leftText: "Collections/Due",
      rightText: goalCompletions?.current_month_paid_amount ? `${formatCurrency(goalCompletions?.current_month_paid_amount)} / ${formatCurrency(goalCompletions?.current_month_payment_due)}` : "0/0",
      title: `Monthly Goal Completion (${progressBarPercent?.month}%)`,
    },
    {
      width: progressBarPercent?.year ? `${progressBarPercent?.year}%` : "00%",
      color: "bg-danger",
      leftText: "Collections/Due",
      rightText: goalCompletions?.current_year_paid_amount ? `${formatCurrency(goalCompletions?.current_year_paid_amount)} / ${formatCurrency(goalCompletions?.current_year_payment_due)}` : "0/0",
      title: `Yearly Goal Completion (${progressBarPercent?.year}%)`,
    },
  ];

  return (
    <div className="loan-details-container">
      <div className="text-end">
        <button
          className="btn btn-primary show-loans-btn"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseLoans"
          aria-controls="collapseLoans"
          onClick={toggleCollapse}
          aria-expanded={!isCollapsed}
        >
          {isCollapsed ? "View Loan Details" : "Hide Loan Details"}
        </button>
      </div>

      <div class="collapse show" id="collapseLoans">
        <div class="card card-body card-body-loan-container">
          <div className="loan-cards-container">
            {loanCardInformation.map((details) => (
              <LoanDetailCard
                icon={details.icon}
                iconText={details.iconText}
                title={details.title}
                text1={details.text1}
                text2={details.text2}
              />
            ))}
          </div>

          <div className="loan-status-container">
            <p className="loan-status-header">Open/Fully Paid Loans</p>
            <div className="progress-bar-containers">
              {progressBarInformation.map((details) => (
                <LoanProgressBar
                  width={details.width}
                  color={details.color}
                  leftText={details.leftText}
                  rightText={details.rightText}
                  title={details.title}
                />
              ))}
            </div>
          </div>


          <div className="loan-status-container">
            <p className="loan-status-header">Funnel</p>
            <div className="loan-cards-container mt-3">
              {loanCard2Information.map((details, key) => (
                <LoanDetailCardNew
                  icon={details.icon}
                  iconText={details.iconText}
                  title={details.title}
                  text1={details.text1}
                  text2={details.text2}
                  count={key}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoanDetails;
